import React from 'react';
import { HiX } from 'react-icons/hi';
import { IButton } from '../../../interfaces/components/button.interface';

const CancelBtn: React.FC<IButton> = ({ callback, classname }) => {
  return (
    <main className={`my-6 text-xl ${classname && classname} `}>
      <button onClick={callback}>
        <HiX />
      </button>
    </main>
  );
};

export default CancelBtn;
